import { render } from "./phoneRed.vue?vue&type=template&id=21599593"
import script from "./phoneRed.vue?vue&type=script&lang=js"
export * from "./phoneRed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__